import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-scroll';


export default class LinkWithHashChange extends React.Component {
  constructor(props) {
    super(props);
    this.onLinkClick = this.onLinkClick.bind(this);
  }

  onLinkClick() {
    const target = document.getElementById(this.props.to);
    if (window.HeadTermState && target) {
      // Set the offset for SEO-side scrolling code
      window.HeadTermState.scrollPositionOffset = Math.abs(this.props.offset);

      // Wait for the Link element to handle scrolling, then set the
      // new scroll position
      setTimeout(() => {
        const newScrollPositionY = document.querySelector('html, body').scrollTop;
        window.HeadTermState.scrollPositionY = newScrollPositionY;
      }, 1100);
    }

    // Update the history entry
    // We do this so hitting the back button causes a return to the last visited
    // section or section item
    const newHref = `${location.protocol}//${location.host}${location.pathname}#${this.props.to}`;
    window.history.pushState(null, null, newHref);
  }

  render() {
    return (
      <Link
        {...this.props}
        hashSpy={false}
        offset={-50}
        smooth
      >
        <div
          className="seo-smoothscroll-link"
          onClick={this.onLinkClick}
        >
          {this.props.children}
        </div>
      </Link>
    );
  }
}

LinkWithHashChange.defaultProps = {
  children: null,
  offset: 0,
};

LinkWithHashChange.propTypes = {
  children: PropTypes.oneOfType(
    [
      PropTypes.node,
      PropTypes.arrayOf(PropTypes.node),
    ]),
  offset: PropTypes.number,
  to: PropTypes.string.isRequired,
};



// WEBPACK FOOTER //
// ./src-react/LinkWithHashChange/index.jsx